"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ui_components_1 = require("@idp/ui-components");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var utils_1 = require("@idp/ui-components/utils");
var styles = require("./PrepaidCart.scss");
var DueAmount_1 = require("../ExpressView/DueAmount/DueAmount");
var RemoveModalContent_1 = require("../shared/RemoveModalContent");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var CartViewPanelProps_1 = require("../../panels/CartViewPanel/CartViewPanelProps");
var CartViewPanel_1 = require("../../panels/CartViewPanel");
var Api_1 = require("../../../api/Api");
var ReportingService_1 = require("../../../api/ReportingService");
var StateProvider_1 = require("../../../api/StateProvider");
var localdatastore_1 = require("../../../config/localdatastore");
var icons = require("../../../styles/ccc-icons-cart.scss");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var Common = require("../../../utils/CommonUtilFuntions");
var Utils = require("../../../utils/UtilityFunctions");
var EditAndRemove_1 = require("../../CommonCart/common/EditAndRemove");
var SaveRetrieveCart_1 = require("../../cards/SaveRetrieveCart");
var cartUtils = require("../../../utils/CartUtilFunctions");
var components_1 = require("@idp/duc/components");
var wirelessRTI = require("./../WirelessCart/WirelessRTI");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var PrepaidCart = /** @class */ (function (_super) {
    __extends(PrepaidCart, _super);
    function PrepaidCart(props) {
        var _this = _super.call(this, props) || this;
        _this.prepaidremoveItemsLinkLabel = 'Remove AT&T PREPAID';
        _this.billCodesArry = new Array();
        _this.showEstDelivery = false;
        _this.expUpdueTodayLegal = {};
        _this.expUpdueMonthlyLegal = {};
        _this.isMonthlyPlan = false;
        _this.dueMonthlyShown = false;
        _this.displayTax = function (orderPriceInfo) {
            return (React.createElement("div", null,
                React.createElement("div", { className: styles.dottedLine }),
                React.createElement("div", { className: styles.lineItems },
                    _this.getTaxComponent(orderPriceInfo),
                    _this.getSalesTax(orderPriceInfo, true, false)),
                cartUtils.isDisplayPrepaidBillingTax() &&
                    React.createElement("div", { className: [styles.lineItems, styles.taxLineItem].join(' ') },
                        _this.getTaxComponent(orderPriceInfo, true),
                        _this.getSalesTax(orderPriceInfo, true, true)),
                cartUtils.isDisplayPrepaidBillingTax() &&
                    React.createElement("div", { className: styles.planTaxSubLabel }, _this.cartSummaryCMSData.taxNotCalculatedSubText)));
        };
        _this.state = {
            accessFeeHelpModalDisplay: false,
            bogoSeeOfferModalDisplayed: false,
            isRemoveModalOpen: false,
            legalContenFound: false,
        };
        _this.cartSummaryCMSData = wlsUtils.getWlsCmsData();
        _this.initializeEvents();
        _this.onRemoveClick = _this.onRemoveClick.bind(_this);
        _this.toggleRemoveModal = _this.toggleRemoveModal.bind(_this);
        _this.expupDueMonthlySection = _this.expupDueMonthlySection.bind(_this);
        _this.expupDueTodaySection = _this.expupDueTodaySection.bind(_this);
        _this.expupDueOnFirstBillSection = _this.expupDueOnFirstBillSection.bind(_this);
        _this.api = new Api_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.getEstDeliveryDates = _this.getEstDeliveryDates.bind(_this);
        _this.setDeliveryDates = _this.setDeliveryDates.bind(_this);
        _this.displayPromotions = _this.displayPromotions.bind(_this);
        _this.reportingService = new ReportingService_1.default();
        _this.savecartModalRef = React.createRef();
        return _this;
    }
    PrepaidCart.prototype.componentWillMount = function () {
        var _this = this;
        this.payload = Utils.getCartResp();
        if (this.payload && this.payload.wirelessCart) {
            this.cartData = this.payload.wirelessCart;
            this.cartMetaData = this.payload.metadata && this.payload.metadata.metadata &&
                this.payload.metadata.metadata.wirelessMetadata;
            var losgs = this.cartData.losgs;
            Object.values(losgs).forEach(function (losg) {
                Object.values(losg.lineItems).forEach(function (lineItem) {
                    if (lineItem.itemType.toUpperCase() === 'DEVICE') {
                        _this.billCodesArry.push({
                            billCode: lineItem.billingCode,
                            type: lineItem.itemType,
                        });
                    }
                });
                Object.values(losg.lineItems).forEach(function (lineItem) {
                    if (lineItem && lineItem.itemType && lineItem.uiDisplayLineItem &&
                        lineItem.itemType.toUpperCase() === 'VOICEPLAN') {
                        _this.isMonthlyPlan = lineItem && lineItem.planType && lineItem.planType.toLowerCase() === 'monthly';
                    }
                });
            });
            this.showEstDelivery = true;
            if (this.payload && this.payload.shippingDetails && this.payload.shippingDetails.shippingMethod &&
                (this.payload.shippingDetails.shippingMethod === 'dropOffShippingGroup'
                    || this.payload.shippingDetails.shippingMethod === 'storePickUpShippingGroup'
                    || this.payload.shippingDetails.shippingMethod === 'premiumDeliveryShippingGroup')) {
                this.showEstDelivery = false;
            }
        }
    };
    PrepaidCart.prototype.componentDidMount = function () {
        this.getEstDeliveryDates();
        var cartViewPanelData = this.getCartViewPanelData(this.cartData);
        if (this.props && this.props.prepaidEvents) {
            this.expUpdueTodayLegal = this.props.prepaidEvents.getLegalData(cartViewPanelData.dueTodayModalLegalContents);
            this.expUpdueMonthlyLegal = this.props.prepaidEvents.getLegalData(cartViewPanelData.dueMonthlyModalLegalContents);
        }
    };
    PrepaidCart.prototype.onRemoveClick = function () {
        var _this = this;
        this.props.events.doLoading(true);
        var editLink = Utils.getEditLinkUrl(this.cartMetaData.editUrl);
        this.stateManager.set('editLinkUrl', { url: editLink });
        var isBundleCart = Utils.isBundleinCart().isBundle;
        this.reportingService.reportSystemEventForSelectedAction(false, '-2', this.identifyPreapidCart() ? this.prepaidremoveItemsLinkLabel :
            this.cartSummaryCMSData.removeItemsLinkLabel, isBundleCart ?
            ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT : ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, undefined);
        this.api.emptyAnyLOBCart('WIRELESS').then(function () {
            Utils.onCartRemoveLob(true);
            _this.reportingService.reportSystemEventForSelectedAction(false, '0', _this.identifyPreapidCart() ? _this.prepaidremoveItemsLinkLabel :
                _this.cartSummaryCMSData.removeItemsLinkLabel, isBundleCart ?
                ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT : ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, undefined);
            _this.props.events.doLoading(false);
        }).catch(function (err) {
            _this.props.events.doLoading(false);
            _this.toggleRemoveModal();
            _this.reportingService.reportSystemEventForSelectedAction(true, undefined, _this.identifyPreapidCart() ? _this.prepaidremoveItemsLinkLabel :
                _this.cartSummaryCMSData.removeItemsLinkLabel, isBundleCart ?
                ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT : ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, 'Error in remvoing cart: ' + JSON.stringify(err));
        });
    };
    PrepaidCart.prototype.toggleRemoveModal = function () {
        var _this = this;
        this.setState({ isRemoveModalOpen: !this.state.isRemoveModalOpen }, function () {
            if (_this.state.isRemoveModalOpen) {
                _this.reportingService.fireLinkClickWithOutPageLoad(_this.cartSummaryCMSData.removeItemsLinkLabel, ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
            }
            else {
                _this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            }
        });
    };
    PrepaidCart.prototype.getLineItemName = function (lineItem) {
        if (lineItem && lineItem.fees && lineItem.fees.feeId === 'ACT') {
            return this.cartSummaryCMSData.activationFee;
        }
        else if (lineItem) {
            return Common.replaceAmpWithAnd(lineItem.displayName);
        }
        return '';
    };
    PrepaidCart.prototype.getFinalPrice = function (price) {
        var finalPrice = 0.00;
        if (price && price.baseAmount && price.amount) {
            if (price.baseAmount && price.baseAmount.toString() !== '0.00') {
                finalPrice = price.baseAmount;
            }
            else {
                finalPrice = price.amount;
            }
        }
        return finalPrice;
    };
    PrepaidCart.prototype.getVoiceItemPrice = function (losg) {
        var prepayPrice = 0;
        var lineItems = Object.keys(losg && losg.lineItems);
        var prepayFeeItem = lineItems && lineItems.find(function (lineItem) {
            if (losg && losg.lineItems &&
                losg.lineItems[lineItem] &&
                losg.lineItems[lineItem].itemType &&
                losg.lineItems[lineItem].itemType === 'PREPAYFEE') {
                return lineItem;
            }
            return '';
        });
        prepayPrice = losg && losg.lineItems && losg.lineItems[prepayFeeItem] &&
            losg.lineItems[prepayFeeItem] &&
            losg.lineItems[prepayFeeItem].price &&
            losg.lineItems[prepayFeeItem].price.baseAmount;
        return { price: prepayPrice };
    };
    PrepaidCart.prototype.getSalesTax = function (orderPriceInfo, isPlan, showPrepaidBillTax) {
        var taxData = (React.createElement("div", null,
            React.createElement(ui_components_1.Label, { testId: utils_1.default('WRLS', 'PriceContainer', 'EmptyTaxText'), data: { text: '$--.--' }, options: { className: styles.salesTaxPrice } })));
        if (isPlan && (((orderPriceInfo === null || orderPriceInfo === void 0 ? void 0 : orderPriceInfo.taxCalculated) && !showPrepaidBillTax)
            || (showPrepaidBillTax && orderPriceInfo.prepaidTaxCalculated))) {
            taxData = (React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'PriceContainer', 'EstimatedSalesTax'), data: { price: showPrepaidBillTax ? orderPriceInfo.prepaidTaxAmount : orderPriceInfo.tax }, options: { decimalPoints: 2, type: PriceContainerProps_1.PricingType.XSMALL, className: styles.salesTaxPrice } }));
        }
        return taxData;
    };
    PrepaidCart.prototype.promoCycleSuffix = function (price, cycle) {
        var suffix = '';
        var ostElement = '';
        var catoElement = '';
        switch (cycle) {
            case 'QUATERLY':
                suffix = '/qa.';
                ostElement = '-$' + price + suffix;
                catoElement = 'negative dollar' + price + 'per quaterly';
                break;
            case 'WEEKLY':
                suffix = '/wk.';
                ostElement = '-$' + price + suffix;
                catoElement = 'negative dollar' + price + 'per weekly';
                break;
            case 'MONTHLY':
                suffix = '/mo.';
                ostElement = '-$' + price + suffix;
                catoElement = 'negative dollar' + price + 'per month';
                break;
            default:
                suffix = '';
                ostElement = '-$' + price + suffix;
                catoElement = 'negative dollar' + price;
        }
        if (parseFloat(price) === 0) {
            return (React.createElement(React.Fragment, null));
        }
        else {
            return (React.createElement("span", null,
                React.createElement("span", { "aria-hidden": "true" }, ostElement),
                React.createElement("span", { className: styles.hiddenSpoken }, catoElement)));
        }
    };
    PrepaidCart.prototype.organizeLineItems = function (itemA, itemB) {
        return PrepaidCart.WIRELESS_LINE_ITEM_PRIORITY.indexOf(itemA.itemType.toUpperCase()) >
            PrepaidCart.WIRELESS_LINE_ITEM_PRIORITY.indexOf(itemB.itemType.toUpperCase()) ? 1 : -1;
    };
    PrepaidCart.prototype.getPlanType = function () {
        return CartViewPanelProps_1.PlanType.WIRELESS_PREPAID;
    };
    PrepaidCart.prototype.getCartViewPanelData = function (cart) {
        var dueTodayPriceAmount = 0;
        var dueMonthlyPriceAmount = 0;
        var due1stBillPriceAmount = 0;
        if (typeof cart.totalLobDueToday !== 'undefined') {
            dueTodayPriceAmount = cart.totalLobDueToday;
        }
        if (typeof cart.totalLobDueMonthly !== 'undefined') {
            dueMonthlyPriceAmount = cart.totalLobDueMonthly;
        }
        if (typeof cart.totalLob1stBill !== 'undefined') {
            due1stBillPriceAmount = cart.totalLob1stBill;
        }
        if (Object.values(cart.losgs)[0].losgType.toUpperCase() === 'CHANGE') {
            return {
                due1stBillPrice: due1stBillPriceAmount,
                dueMonthlyLabel: this.cartSummaryCMSData.dueMonthlyLabel,
                dueMonthlyPrice: dueMonthlyPriceAmount,
                dueTodayPrice: dueTodayPriceAmount,
                lineOfBusinessName: this.identifyPreapidCart() ?
                    this.cartSummaryCMSData.byodPlanLineHeading : this.cartSummaryCMSData.lineOfBusinessName,
                removeItemsLinkLabel: this.identifyPreapidCart() ?
                    this.prepaidremoveItemsLinkLabel : this.cartSummaryCMSData.removeItemsLinkLabel,
            };
        }
        else {
            var dueMonthlyLegalContents = {
                legalModalPath: CartUtilFunctions_1.getLegalIDPUrl('onMonthly', this.cartSummaryCMSData, true).legalModalPath,
                legallinkText: CartUtilFunctions_1.getLegalIDPUrl('onMonthly', this.cartSummaryCMSData, true).legallinkText,
                shortText: CartUtilFunctions_1.getLegalIDPUrl('onMonthly', this.cartSummaryCMSData, true).shortText,
            };
            var dueTodayLegalContents = {
                legalModalPath: CartUtilFunctions_1.getLegalIDPUrl('onToday', this.cartSummaryCMSData, true).legalModalPath,
                legallinkText: CartUtilFunctions_1.getLegalIDPUrl('onToday', this.cartSummaryCMSData, true).legallinkText,
                shortText: CartUtilFunctions_1.getLegalIDPUrl('onToday', this.cartSummaryCMSData, true).shortText,
            };
            var dueFirstMonthLegalContents = {
                legalModalPath: CartUtilFunctions_1.getLegalIDPUrl('onFirstBill', this.cartSummaryCMSData).legalModalPath,
                legallinkText: CartUtilFunctions_1.getLegalIDPUrl('onFirstBill', this.cartSummaryCMSData).legallinkText,
                shortText: CartUtilFunctions_1.getLegalIDPUrl('onFirstBill', this.cartSummaryCMSData).shortText,
            };
            return {
                autopayPlanLabel: this.cartSummaryCMSData && this.cartSummaryCMSData.autopayPlanLabel,
                due1stBillModalLegalContents: dueFirstMonthLegalContents,
                due1stBillPrice: due1stBillPriceAmount,
                dueMonthlyLabel: this.cartSummaryCMSData.dueMonthlyLabel,
                dueMonthlyModalLegalContents: dueMonthlyLegalContents,
                dueMonthlyPrice: dueMonthlyPriceAmount,
                dueTodayModalLegalContents: dueTodayLegalContents,
                dueTodayPrice: dueTodayPriceAmount,
                lineOfBusinessName: this.identifyPreapidCart() ?
                    this.cartSummaryCMSData.byodPlanLineHeading : this.cartSummaryCMSData.lineOfBusinessName,
                removeItemsLinkLabel: this.identifyPreapidCart() ?
                    this.prepaidremoveItemsLinkLabel : this.cartSummaryCMSData.removeItemsLinkLabel,
            };
        }
    };
    PrepaidCart.prototype.sortLogs = function (losgA, losgB) {
        return losgA.sequence - losgB.sequence;
    };
    PrepaidCart.prototype.render = function () {
        var _this = this;
        var isWirelessApplicable = false;
        var losgs = this.cartData.losgs;
        var payload = Utils.getCartResp();
        var isPSC = this.cartData && this.cartData._cartCreationSource === 'PSC';
        if (payload) {
            this.cartData = payload.wirelessCart;
            this.cartMetaData = payload.metadata && payload.metadata.metadata &&
                payload.metadata.metadata.wirelessMetadata;
            isWirelessApplicable = !!this.cartData;
            losgs = isWirelessApplicable && this.cartData.losgs;
        }
        return (React.createElement("div", null, isWirelessApplicable &&
            React.createElement("div", { className: styles.wirelessCartView },
                this.isPrepaidExpressCart() && this.showPrepaidExpressView(losgs),
                !this.isPrepaidExpressCart() &&
                    React.createElement(CartViewPanel_1.default, { testId: utils_1.default('Wireless', 'CartViewPanel', 'LineItem'), data: this.getCartViewPanelData(this.cartData), events: this.cartViewEvents, options: {
                            hideEditAndRemove: (this.cartData._cartCreationSource === 'PSC'),
                            isPrepaidMonthlyPlan: this.isMonthlyPlan,
                            isRemoveAllButtonApplicable: (this.cartData.eligibleActions.indexOf('REMOVE') > -1),
                            isTaxApplied: true,
                            planType: this.getPlanType(),
                            showAccordions: this.props.options && !!this.props.options.showBundlesTreatment,
                        } }, this.displayCart()),
                isPSC && this.payload.wirelessCart.addAnotherDeviceEligible
                    && this.addAnotherLine(),
                React.createElement(ui_components_1.Modal, { testId: utils_1.default('WLS', 'Modal', 'ConfirmRemove'), options: {
                        center: true,
                        className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                        show: this.state.isRemoveModalOpen,
                        showClose: true,
                        size: ModalProps_1.ModalSizes.MEDIUM,
                    }, events: {
                        onClose: function () {
                            _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
                            _this.toggleRemoveModal();
                        },
                    } },
                    React.createElement(RemoveModalContent_1.default, { testId: utils_1.default('WLS', 'RemoveModalContent', 'ConfirmRemove'), events: {
                            onCancelClick: function () {
                                _this.toggleRemoveModal();
                            },
                            onRemoveClick: function () {
                                _this.toggleRemoveModal();
                                _this.onRemoveClick();
                            },
                        }, data: {
                            currentLOB: 'WLS',
                            isBundleinCart: Utils.isBundleinCart().isBundleWithoutAccessory,
                            isSonosinCart: Utils.IsSONOSAccessoryInCart(),
                        } })))));
    };
    PrepaidCart.prototype.getTaxComponent = function (orderPriceInfo, isPlan) {
        var taxLabel = '';
        var toolTipText;
        if (isPlan) {
            toolTipText = React.createElement("span", null, this.cartSummaryCMSData.prepaidPlanTaxToolTip || '');
            taxLabel = this.cartSummaryCMSData.estimatedSalesPlanTax || '';
        }
        else if (cartUtils.isDisplayPrepaidBillingTax()) {
            toolTipText = this.cartSummaryCMSData.equipmentTaxToolTip || '';
            taxLabel = this.cartSummaryCMSData.estimatedSalesEquipmentTax || '';
        }
        else {
            taxLabel = this.cartSummaryCMSData.estimatedSalesTax;
            toolTipText = (orderPriceInfo !== null && orderPriceInfo.taxCalculated === true) ?
                React.createElement("span", null, this.cartSummaryCMSData.taxEstimated) :
                (orderPriceInfo !== null && orderPriceInfo.taxCalculated === false) ?
                    React.createElement("span", null, this.cartSummaryCMSData.taxApiDown) : '';
        }
        return (React.createElement("div", null,
            React.createElement("span", { className: styles.salesTaxName, "data-test-id": "WRLS_Label_EstimatedSalesTax" }, taxLabel),
            React.createElement(components_1.Tooltip, { content: toolTipText, testId: utils_1.default('Tooltip', 'Prepaid_EstiamtedSalesTax'), className: CartConfiguration_scss_1.ducTooltip, position: "top", boxWidth: 300, offset: 75, zIndex: true },
                React.createElement(components_1.IconSvg, { size: 16, colorClass: "color-ui-black", svgNodeStr: Utils.GET_ICON_SVG.QUESTION }))));
    };
    PrepaidCart.prototype.saveRetrieveCart = function () {
        var _this = this;
        return (React.createElement(SaveRetrieveCart_1.default, { ref: this.savecartModalRef, data: { payload: this.payload }, events: {
                authSaveErrorMsg: this.props && this.props.prepaidEvents &&
                    this.props.prepaidEvents.authSaveCartMessage,
                emailInfoUpdated: function () { return _this.props && _this.props.prepaidEvents &&
                    _this.props.prepaidEvents.onSubmit; },
            }, options: { isPrepaidExpView: true } }));
    };
    PrepaidCart.prototype.addAnotherLine = function () {
        var redirectionUrl = Utils.isPrepaidFlowType() ? '/buy/prepaid-phones/' : '';
        return (React.createElement("div", { className: styles.addAnotherLine },
            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Cart', 'Link', 'Add another line'), className: CartConfiguration_scss_1.rennyCommonLink, 
                // tslint:disable-next-line: jsx-no-lambda
                onClick: function () { CartUtilFunctions_1.getRedirectionUrl('', redirectionUrl, 'Add another line'); } }, "Add another line")));
    };
    PrepaidCart.prototype.displayCart = function () {
        var _this = this;
        var isWirelessApplicable = false;
        var losgs = this.cartData.losgs;
        var isPrepaidMultiline = Object.values(losgs).length > 1 ? true : false;
        var pricingType = PriceContainerProps_1.PricingType.XSMALL;
        var payload = Utils.getCartResp();
        var orderPriceInfo;
        if (payload) {
            orderPriceInfo = payload.orderPriceInfo;
            this.cartData = payload.wirelessCart;
            this.cartMetaData = payload.metadata && payload.metadata.metadata &&
                payload.metadata.metadata.wirelessMetadata;
            isWirelessApplicable = !!this.cartData;
            losgs = isWirelessApplicable && this.cartData.losgs;
        }
        return (React.createElement(React.Fragment, null,
            Object.values(losgs)
                .sort(this.sortLogs)
                .map(function (losg, index) {
                var newLine = _this.cartSummaryCMSData.lineLabel;
                var lineDisplayHeaderText = _this.expressFlowLineNames(losg, index);
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", null,
                        index > 0 ? React.createElement("div", { key: index - 1, className: styles.dashedLine }) : '',
                        isPrepaidMultiline && !_this.isPrepaidExpressCart() &&
                            Object.values(losg.lineItems).sort(_this.organizeLineItems).map(function (lineItem) {
                                if (lineItem.uiDisplayLineItem &&
                                    lineItem.itemType.toUpperCase() === 'DEVICE') {
                                    return (React.createElement("div", { className: styles.editRemoveContainer },
                                        React.createElement(ui_components_1.Label, { data: {
                                                isDecodingRequired: false,
                                                text: newLine + " " + (index + 1),
                                            }, options: {
                                                className: styles.line,
                                                tabIndex: 0,
                                            } }),
                                        _this.displayEditRemove(losg, losgs, lineItem)));
                                }
                                else {
                                    return (React.createElement(React.Fragment, null, " "));
                                }
                            }),
                        _this.isPrepaidExpressCart() &&
                            React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: lineDisplayHeaderText }, options: { className: styles.expupLinename, tabIndex: 0 }, testId: utils_1.default('WRLS', 'Device', "Header_" + index) }),
                        React.createElement("div", { key: index, className: styles.losg }, Object.values(losg.lineItems).sort(_this.organizeLineItems).map(function (lineItem, secindex) {
                            var lineItemPriceData = wlsUtils.getLineItemPriceData(lineItem, false, false);
                            return (React.createElement("div", { key: "lineItem_" + secindex },
                                lineItem.uiDisplayLineItem &&
                                    lineItem.itemType.
                                        toUpperCase() === 'DEVICE' &&
                                    React.createElement("div", { key: secindex, className: [styles.lineItems].join(' ') },
                                        React.createElement("div", { tabIndex: 0 },
                                            React.createElement(ui_components_1.Label, { data: {
                                                    isDecodingRequired: false,
                                                    text: _this.getLineItemName(lineItem),
                                                }, options: { className: styles.itemName } })),
                                        lineItem.price &&
                                            React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "lineItem_" + secindex), data: lineItemPriceData.lineItemPrice, options: {
                                                    className: styles.lineItem,
                                                    decimalPoints: 2,
                                                    type: pricingType,
                                                } })),
                                lineItem.preOwnedIndicator && lineItem.uiDisplayLineItem &&
                                    _this.cartSummaryCMSData.preOwnedDeviceLabel && lineItem.itemType.
                                    toUpperCase() === 'DEVICE' &&
                                    React.createElement("div", { key: secindex, className: [styles.lineItems].join(' ') },
                                        React.createElement("span", { className: [styles.itemName, styles.preOwnedLabel].join(' ') }, _this.cartSummaryCMSData.preOwnedDeviceLabel)),
                                lineItem.promotionReferences &&
                                    lineItem.itemType.toUpperCase() !== 'VOICEPLAN' &&
                                    _this.displayPromotions(lineItem)));
                        })),
                        React.createElement("div", { key: index + 1, className: styles.losg }, Object.values(losg.lineItems).map(function (lineItem, secindex) {
                            var cmsData;
                            var planName = '';
                            if (lineItem.uiDisplayLineItem &&
                                lineItem.itemType.toUpperCase() === 'VOICEPLAN') {
                                cmsData = _this.cartSummaryCMSData.plansListArray &&
                                    _this.cartSummaryCMSData.plansListArray.contentReference
                                        .find(function (plan) {
                                        return plan.billCode === lineItem.billingCode;
                                    });
                                if (cmsData && cmsData.planName) {
                                    planName = cmsData.planName;
                                }
                            }
                            var lineItemPriceData = _this.getVoiceItemPrice(losg);
                            return (React.createElement("div", { key: "lineItem_" + secindex },
                                lineItem.uiDisplayLineItem &&
                                    lineItem.itemType.toUpperCase() === 'VOICEPLAN' &&
                                    lineItem.billingCode.toUpperCase() !== 'EPFL' &&
                                    React.createElement(React.Fragment, null,
                                        losg.losgType.toUpperCase() !== 'CHANGE' &&
                                            React.createElement("div", { className: styles.line },
                                                React.createElement(ui_components_1.Label, { data: {
                                                        isDecodingRequired: false,
                                                        text: _this.cartSummaryCMSData
                                                            .byodPlanLineHeading + ' ' +
                                                            planName,
                                                    }, options: {
                                                        className: styles.itemName,
                                                    } })),
                                        React.createElement("div", { className: styles.lineItems },
                                            React.createElement("div", null,
                                                React.createElement(ui_components_1.Label, { data: {
                                                        isDecodingRequired: false,
                                                        text: lineItem.displayName,
                                                    }, options: {
                                                        className: styles.itemName,
                                                    } }),
                                                lineItem.planType !== 'NonMonthly' &&
                                                    _this.toolTip('Prepaid_ByodAutopay', _this.cartSummaryCMSData.byodAutoPayTip)),
                                            lineItem.price &&
                                                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "lineItem_" + secindex), data: lineItemPriceData, options: {
                                                        className: styles.lineItem,
                                                        decimalPoints: 2,
                                                        type: pricingType,
                                                    } }))),
                                lineItem.uiDisplayLineItem &&
                                    lineItem.itemType.toUpperCase() === 'VOICEPLAN' &&
                                    lineItem.billingCode.toUpperCase() === 'EPFL' &&
                                    React.createElement(React.Fragment, null, losg.losgType.toUpperCase() !== 'CHANGE' &&
                                        React.createElement("div", { className: styles.lineItems },
                                            React.createElement("div", null,
                                                React.createElement(ui_components_1.Label, { data: { text: lineItem.displayName }, options: { className: styles.itemName } }),
                                                React.createElement(ui_components_1.Label, { data: {
                                                        text: '(' +
                                                            _this.cartSummaryCMSData.byodUsagePlanLabel + ')',
                                                    }, options: { className: styles.losgName } })),
                                            lineItem.price &&
                                                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "lineItem_" + secindex), data: lineItemPriceData, options: {
                                                        className: styles.lineItem,
                                                        decimalPoints: 2,
                                                        type: pricingType,
                                                    } }))),
                                _this.cartMetaData && _this.cartMetaData.losgs &&
                                    _this.cartMetaData.losgs[losg.id] &&
                                    _this.cartMetaData.losgs[losg.id]._autopaySelected &&
                                    lineItem.promotionReferences &&
                                    lineItem.itemType.toUpperCase() === 'VOICEPLAN' &&
                                    _this.displayPromotions(lineItem)));
                        })),
                        React.createElement("div", { key: index + 2, className: styles.losg }, Object.values(losg.lineItems)
                            .map(function (lineItem, secindex) {
                            return (React.createElement("div", { key: "lineItem_" + secindex }, lineItem.uiDisplayLineItem &&
                                lineItem.itemType.toUpperCase() === 'ACCESSORY' &&
                                React.createElement(React.Fragment, null,
                                    React.createElement("div", { key: secindex, className: styles.lineItems },
                                        React.createElement("div", null,
                                            React.createElement(ui_components_1.Label, { data: {
                                                    isDecodingRequired: false,
                                                    text: _this.cartSummaryCMSData
                                                        .byodPaymentHeading,
                                                }, options: {
                                                    className: styles.itemName,
                                                } }),
                                            _this.toolTip('Preapid_ByodAutopayTooltip', _this.cartSummaryCMSData.byodPaymenttoolTip)),
                                        lineItem.price &&
                                            React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "lineItem_" + secindex), data: { price: _this.getFinalPrice(lineItem.price) }, options: {
                                                    className: styles.lineItem,
                                                    decimalPoints: 2,
                                                    type: pricingType,
                                                } })))));
                        })),
                        !isPrepaidMultiline && losg.losgType.toUpperCase() === 'NEW' &&
                            orderPriceInfo !== null && _this.displayTax(orderPriceInfo))));
            }),
            isPrepaidMultiline && orderPriceInfo !== null &&
                this.displayTax(orderPriceInfo)));
    };
    PrepaidCart.prototype.toolTip = function (testId, tooltipContent) {
        return (React.createElement(components_1.Tooltip, { content: React.createElement("span", { dangerouslySetInnerHTML: { __html: tooltipContent } }), testId: utils_1.default('Tooltip', testId), className: CartConfiguration_scss_1.ducTooltip, position: "top", boxWidth: 300, offset: 75, zIndex: true },
            React.createElement(components_1.IconSvg, { size: 16, colorClass: "color-ui-black", svgNodeStr: Utils.GET_ICON_SVG.QUESTION })));
    };
    PrepaidCart.prototype.initializeEvents = function () {
        var _this = this;
        this.cartViewEvents = {
            onEdit: function () {
                var wirelessDetails = _this.stateManager.get(localdatastore_1.getNamespace('APPSHELL'), 'wirelessDetails');
                var onEditURL = _this.cartMetaData.editUrl +
                    ((wirelessDetails && wirelessDetails.experienceType
                        && _this.identifyPreapidCart()) ? '?wlsview=' +
                        wirelessDetails.experienceType : '');
                _this.props.events.onEdit('WIRELESS', onEditURL);
            },
            onRemove: function () {
                _this.toggleRemoveModal();
            },
        };
    };
    PrepaidCart.prototype.identifyPreapidCart = function () {
        return this.cartMetaData && this.cartMetaData.paymentType &&
            this.cartMetaData.paymentType === CartViewPanelProps_1.PlanType.WIRELESS_PREPAID;
    };
    PrepaidCart.prototype.showPrepaidExpressView = function (losgs) {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("section", { className: styles.expupSectionWhite }, Object.values(losgs).sort(this.sortLogs).map(function (losg, index) {
                return (React.createElement("div", { key: "lineItem" + index, className: styles.expupProductInfo },
                    Object.values(losg.lineItems).sort(_this.organizeLineItems).map(function (lineItem, secindex) {
                        if (lineItem.uiDisplayLineItem && lineItem.itemType.toUpperCase() === 'DEVICE') {
                            var lineDisplayHeaderText = _this.expressFlowLineNames(losg, index);
                            var baseURL = window && window.location && window.location.protocol + "//" + window.location.host;
                            var imageUrl = void 0;
                            if (lineItem.hardGood && lineItem.hardGood.hardGoodType === 'SIM') {
                                imageUrl = 'https://www.att.com/idpassets/global/icons/svg/devices/pictogram_sim-card_96.svg';
                            }
                            else if (lineItem.hardGood && lineItem.hardGood.productImageUrl) {
                                imageUrl = "" + baseURL + lineItem.hardGood.productImageUrl;
                            }
                            else {
                                imageUrl = baseURL + "/idpassets/global/devices/missing-image@2x.png";
                            }
                            var lineItemName = _this.cartData._cartCreationSource === 'PSC' ?
                                [styles.lineItemName, styles.pscDeviceName].join(' ') : styles.lineItemName;
                            var isPrepaidMultiline = Object.values(losgs).length > 1 ? true : false;
                            return (React.createElement(React.Fragment, { key: "lineItemInfo" + index + "_" + secindex },
                                React.createElement("div", null,
                                    isPrepaidMultiline && index !== 0 && React.createElement("div", { className: styles.expupDivider }),
                                    React.createElement("div", { className: [styles.expupLineinfo, styles.displayFlex,
                                            styles.expupDevicename].join(' ') },
                                        React.createElement("div", null,
                                            React.createElement("img", { className: lineItem.hardGood &&
                                                    lineItem.hardGood.hardGoodType === 'SIM' ?
                                                    styles.simCardImg : styles.deviceImg, src: imageUrl, alt: (lineItem.hardGood && lineItem.hardGood.model) ?
                                                    lineItem.hardGood.model : 'image' })),
                                        React.createElement("div", { tabIndex: 0, className: lineItemName },
                                            React.createElement("div", { className: styles.editRemoveContainer },
                                                React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false,
                                                        text: lineDisplayHeaderText }, options: { className: styles.expupLinename, tabIndex: 0 }, testId: utils_1.default('WRLS', 'Device', "Header_" + index) }),
                                                _this.displayEditRemove(losg, losgs, lineItem)),
                                            React.createElement("div", null,
                                                React.createElement("div", { className: styles.expupItemname }, _this.displayDeviceLine(lineItem)),
                                                lineItem.preOwnedIndicator &&
                                                    _this.cartSummaryCMSData.preOwnedDeviceLabel &&
                                                    React.createElement("div", { className: styles.expupDeliveryDate }, _this.cartSummaryCMSData.preOwnedDeviceLabel)),
                                            React.createElement("div", { className: styles.expupDeliveryDate }, _this.state.showEstDeliveryDate && _this.showEstDelivery &&
                                                _this.setDeliveryDates(lineItem.billingCode)),
                                            React.createElement("div", null, wlsUtils.isCommonDeliveryMethodAvailable(_this.payload) &&
                                                wirelessRTI.displayInventoryNotification(lineItem)),
                                            React.createElement("div", null, _this.incompleteCartMessage(losg)))))));
                        }
                        else {
                            return (React.createElement(React.Fragment, null, " "));
                        }
                    }),
                    losg.requiredToCheckout &&
                        Object.values(losg.requiredToCheckout).map(function (incompletePart, missingIndex) {
                            var lineDisplayHeaderText = _this.expressFlowLineNames(losg, index);
                            var iconClasses = [icons.cccIconCart, icons.cccIconCartLg, icons.cccIconCartMissingDevice,
                                styles.missingDevice];
                            if (incompletePart === 'WLS_DEVICE') {
                                return (React.createElement(React.Fragment, { key: "lineItemInfo" + index + "_" + missingIndex },
                                    React.createElement("div", null,
                                        React.createElement("div", { className: styles.expupDivider }),
                                        React.createElement("div", { className: [styles.expupLineinfo, styles.displayFlex].join(' ') },
                                            React.createElement("span", null,
                                                React.createElement("i", { className: iconClasses.join(' '), role: "img", "aria-label": "add a line" })),
                                            React.createElement("div", { tabIndex: 0, className: styles.lineItemName },
                                                React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: lineDisplayHeaderText }, options: { className: styles.expupLinename, tabIndex: 0 }, testId: utils_1.default('WRLS', 'Device', "Header_" + index) }),
                                                React.createElement("div", null, _this.incompleteCartMessage(losg)))))));
                            }
                            else {
                                return (React.createElement(React.Fragment, null, " "));
                            }
                        })));
            })),
            React.createElement("section", { className: styles.expupSectionWhite },
                React.createElement("div", { className: styles.expupDivider }),
                this.props.options && this.props.options.isExpandView &&
                    this.displayCart(),
                this.expupDueTodaySection(),
                this.expupDueMonthlySection(),
                this.expupDueOnFirstBillSection())));
    };
    PrepaidCart.prototype.displayEditRemove = function (losg, losgs, lineItem) {
        var _this = this;
        var itemType = lineItem && lineItem.itemType && lineItem.itemType.toUpperCase();
        var losgsLength = losgs && Object.values(losgs).length;
        var removeInfo = {
            lineItem: (itemType === 'DEVICE') ? lineItem : {},
            losgId: losg && losg.id ? losg.id : '',
            losgInfo: losg,
            losgsCount: losgsLength,
            qualifierPlanName: this.cartData && this.cartData.qualifierPlanName ?
                this.cartData.qualifierPlanName : '',
            showEditAndRemove: (itemType === 'DEVICE') ? true : false,
        };
        return (removeInfo && removeInfo.showEditAndRemove && this.cartData && (React.createElement(EditAndRemove_1.default, { data: {}, options: { isPrepaidCart: this.isPrepaidExpressCart(), isIconsMode: true }, events: {
                onItemEdit: function () {
                    var _a;
                    _this.props.prepaidEvents.onItemEdit(((_a = _this.cartData) === null || _a === void 0 ? void 0 : _a._cartCreationSource) === 'PSC' ?
                        ((losg === null || losg === void 0 ? void 0 : losg.pscEditUrl) || 'buy/prepaid-phones') : 'buy/wireless/prepaid/devices');
                },
                onItemRemove: function () {
                    _this.props.prepaidEvents.onItemRemove(removeInfo.losgId, removeInfo.lineItem, removeInfo.losgInfo, removeInfo.qualifierPlanName, removeInfo.losgsCount);
                },
            } })));
    };
    PrepaidCart.prototype.isPrepaidExpressCart = function () {
        if (this.props.options && this.props.options.isExpressUpgradeView) {
            return this.props.options.isExpressUpgradeView;
        }
        return false;
    };
    PrepaidCart.prototype.expressFlowLineNames = function (losg, index) {
        if (losg) {
            var lineDisplayHeaderText = void 0;
            var lineNumber = index + 1;
            if (losg.subscriberName && losg.subscriberName.firstName) {
                var lineName = losg.subscriberName.firstName.toUpperCase();
                lineDisplayHeaderText = lineName + "'S " + this.cartSummaryCMSData.lineLabel;
            }
            else {
                lineDisplayHeaderText = this.cartSummaryCMSData.lineLabel + " " + lineNumber;
            }
            return "" + lineDisplayHeaderText;
        }
        return '';
    };
    PrepaidCart.prototype.displayDeviceLine = function (lineItem) {
        if (lineItem.hardGood && lineItem.hardGood.make && lineItem.hardGood.model) {
            var deviceInfo = lineItem.hardGood.make + " " + lineItem.hardGood.model;
            var deviceColor = (lineItem.hardGood.hardGoodType === 'DEVICE' && lineItem.color) ? lineItem.color : '';
            var deviceCapacity = (lineItem.hardGood.hardGoodType === 'DEVICE' && lineItem.capacity) ?
                "- " + lineItem.capacity : '';
            var isSIM = lineItem.hardGood.hardGoodType === 'SIM';
            return (React.createElement("div", null,
                React.createElement("span", null, isSIM &&
                    lineItem.displayName ? lineItem.displayName : deviceInfo),
                React.createElement("br", null),
                !isSIM && React.createElement("span", { className: styles.expupDeviceModel }, deviceColor + " " + deviceCapacity + " ")));
        }
        else {
            return lineItem.displayName;
        }
    };
    PrepaidCart.prototype.setDeliveryDates = function (billCode) {
        var _a, _b;
        var deliveryDate = '';
        if (billCode && this.billCodeRespObj[billCode]) {
            var dateObj = this.billCodeRespObj[billCode];
            if (((_a = dateObj === null || dateObj === void 0 ? void 0 : dateObj.deliveryDates) === null || _a === void 0 ? void 0 : _a.dateFrom) &&
                dateObj.deliveryDates.dateFrom.split(',') !== undefined &&
                dateObj.deliveryDates.dateFrom.split(',').length > 0 && ((_b = dateObj === null || dateObj === void 0 ? void 0 : dateObj.deliveryDates) === null || _b === void 0 ? void 0 : _b.dateTo) &&
                dateObj.deliveryDates.dateTo.split(',') !== undefined &&
                dateObj.deliveryDates.dateTo.split(',').length > 0) {
                deliveryDate = this.cartSummaryCMSData.expupEstDateLabel + "\n                  " + dateObj.deliveryDates.dateFrom.split(',')[0] + " - " + dateObj.deliveryDates.dateTo.split(',')[0];
            }
        }
        return deliveryDate;
    };
    PrepaidCart.prototype.getEstDeliveryDates = function () {
        var _this = this;
        if (this.billCodesArry.length > 0 && this.isPrepaidExpressCart()) {
            this.api.getDeliveryDates(this.billCodesArry).then(function (response) {
                _this.billCodeRespObj = response;
                _this.setState({ showEstDeliveryDate: true });
            }).catch(function (error) {
                _this.setState({ showEstDeliveryDate: false });
            });
        }
    };
    PrepaidCart.prototype.expupDueTodaySection = function () {
        var payload = Utils.getCartResp();
        return (React.createElement("div", { className: [styles.expupDueamount, styles.expupDuetodayContainer].join(' ') },
            this.props.options && this.props.options.isExpandView && React.createElement("div", { className: styles.expupDivider }),
            this.cartData.totalLobDueToday &&
                React.createElement(DueAmount_1.default, { data: {
                        duePrice: this.cartData.totalLobDueToday,
                        dueText: payload.orderPriceInfo.taxCalculated ?
                            this.cartSummaryCMSData.expupDueTodayLabel :
                            this.cartSummaryCMSData.expupDueTodayLabel + "*",
                        isPriceNegative: false,
                        showPrice: true,
                    } })));
    };
    PrepaidCart.prototype.expupDueMonthlySection = function () {
        return (this.cartData && this.cartData.totalLobDueMonthly &&
            this.cartData.totalLobDueMonthly.toString() !== '0.00' &&
            (React.createElement("div", { className: styles.expupDueamount },
                React.createElement(DueAmount_1.default, { data: {
                        duePrice: this.cartData.totalLobDueMonthly,
                        dueText: this.cartSummaryCMSData.expupDueMonthlyLabel,
                        isPriceNegative: false,
                        showPrice: true,
                    } }),
                this.dueMonthlyShown = true,
                this.isMonthlyPlan && React.createElement("span", { className: styles.autopayPlanLabel }, this.cartSummaryCMSData && this.cartSummaryCMSData.autopayPlanLabel ?
                    this.cartSummaryCMSData.autopayPlanLabel : ''))));
    };
    PrepaidCart.prototype.expupDueOnFirstBillSection = function () {
        var _a;
        return (React.createElement("div", { className: styles.expupDueamount },
            ((_a = this.cartData.totalLob1stBill) === null || _a === void 0 ? void 0 : _a.toString()) !== '0.00' &&
                React.createElement(DueAmount_1.default, { data: {
                        duePrice: this.cartData.totalLob1stBill,
                        dueText: this.cartSummaryCMSData.expupDueOnFirstBillLabel + '*',
                        isPriceNegative: false,
                        showPrice: true,
                    } }),
            React.createElement("div", { className: styles.expupDivider }),
            React.createElement("div", { className: styles.font11px },
                this.displayTaxLabel(this.payload),
                "\u00A0",
                React.createElement("span", null, this.showExpUpLegalContent(this.cartData)))));
    };
    PrepaidCart.prototype.displayTaxLabel = function (payload) {
        if (cartUtils.isDisplayPrepaidBillingTax()) {
            if (payload.orderPriceInfo.taxCalculated) {
                if (!this.dueMonthlyShown) {
                    return (React.createElement(React.Fragment, null, " "));
                }
            }
        }
        return (React.createElement("span", null, this.cartSummaryCMSData.expPrepaidTaxLabel));
    };
    PrepaidCart.prototype.showExpUpLegalContent = function (cartData) {
        var _this = this;
        var _a, _b;
        var cartViewPanelData = this.getCartViewPanelData(cartData);
        var linkText = ((_a = cartViewPanelData === null || cartViewPanelData === void 0 ? void 0 : cartViewPanelData.dueTodayModalLegalContents) === null || _a === void 0 ? void 0 : _a.legallinkText) || ((_b = cartViewPanelData === null || cartViewPanelData === void 0 ? void 0 : cartViewPanelData.due1stBillModalLegalContents) === null || _b === void 0 ? void 0 : _b.legallinkText);
        return (React.createElement(React.Fragment, null,
            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('expupSeeDetailsLink', 'legalmodal'), className: styles.expupLegallink, 
                // tslint:disable-next-line: jsx-no-lambda
                onClick: function () {
                    _this.props.prepaidEvents.showLegalModal(true, linkText);
                    _this.setState({ showExpUpLegal: true });
                } }, linkText),
            React.createElement(ui_components_1.Modal, { testId: "ExpUp_Modal_Details", options: {
                    center: true,
                    className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: this.state.showExpUpLegal,
                    showClose: true,
                    size: ModalProps_1.ModalSizes.MEDIUM,
                    tabIndex: 0,
                }, events: { onClose: function () {
                        _this.props.prepaidEvents.showLegalModal(false, 'Close');
                        _this.setState({ showExpUpLegal: false });
                    } } },
                React.createElement("div", { className: styles.legalContainer },
                    React.createElement("div", { className: CartConfiguration_scss_1.mb10 },
                        React.createElement(ui_components_1.Label, { data: { text: 'The legal stuff' }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING24, className: styles.legalHeading } })),
                    this.expUpdueTodayLegal.showLegal &&
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { text: this.expUpdueTodayLegal.modaltitle }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING18, className: styles.legalHeading } }),
                            React.createElement("br", null),
                            React.createElement("p", { dangerouslySetInnerHTML: { __html: this.expUpdueTodayLegal.longtext } }),
                            React.createElement("br", null)),
                    this.expUpdueMonthlyLegal.showLegal &&
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { text: this.expUpdueMonthlyLegal.modaltitle }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING18, className: styles.legalHeading } }),
                            React.createElement("br", null),
                            React.createElement("p", { dangerouslySetInnerHTML: { __html: this.expUpdueMonthlyLegal.longtext } }))))));
    };
    PrepaidCart.prototype.displayPromotions = function (lineItem) {
        var _this = this;
        return (React.createElement(React.Fragment, null, this.cartData.promotions && this.cartData.promotions.length > 0 &&
            lineItem.promotionReferences.map(function (promoRef, promoIndex) {
                var promotion = _this.cartData.promotions.find(function (promo) { return promo.id === promoRef; });
                if (promotion) {
                    var promoPriceData = {
                        billingNote: promotion.promotionCycle &&
                            promotion.promotionCycle.toString(),
                        price: promotion.amount,
                    };
                    var showPriceAmt = true;
                    if (promotion.promotionType && promotion.promotionType === 'BILLCREDITWITHQUALIFIER' ||
                        promotion.promotionType === 'MANUALBILLCREDIT') {
                        showPriceAmt = false;
                    }
                    return (
                    // tslint:disable-next-line:jsx-key
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { key: promoIndex, className: [
                                styles.lineItems,
                                styles.promoText,
                            ].join(' ') },
                            React.createElement("div", { tabIndex: 0 },
                                React.createElement(ui_components_1.Label, { testId: utils_1.default('WRLS', 'Label', "PromotionName\n                                                        " + promoIndex), data: {
                                        isDecodingRequired: false,
                                        text: promotion
                                            .promotionName,
                                    }, options: { className: styles.promoLineItem } })),
                            promotion.amount && showPriceAmt &&
                                React.createElement("div", { tabIndex: 0, className: styles.promoPrice, "data-test-id": "WRLS_Label_PriceContPromo" }, _this.promoCycleSuffix(promoPriceData.price, promoPriceData.billingNote)))));
                }
                else {
                    return (React.createElement(React.Fragment, null, " "));
                }
            })));
    };
    PrepaidCart.prototype.incompleteCartMessage = function (losg) {
        var _this = this;
        return (losg.requiredToCheckout &&
            Object.values(losg.requiredToCheckout).map(function (incompletePart, missingIndex) {
                var iconClasses = [styles.errorMessageIcon, icons.cccIconCart,
                    icons.cccIconCartLg, icons.cccIconCartBadgealert, styles.redColorText];
                var linkClass = [styles.missingErrorMessage, styles.redColorText];
                var messageToShow = '';
                if (incompletePart === 'WLS_PLAN') {
                    messageToShow = _this.cartSummaryCMSData.mixAndMatchPlanMissing;
                }
                else if (incompletePart === 'WLS_DEVICE') {
                    messageToShow = _this.cartSummaryCMSData.mixAndMatchDeviceMissing;
                }
                var postpaidLineItem = incompletePart === 'WLS_PLAN' ?
                    [styles.messageMargin, styles.postpaidLineItem, styles.displayFlex].join(' ') :
                    [styles.postpaidLineItem, styles.displayFlex].join(' ');
                var goBackLink = (React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default(_this.props.testId, 'Link', 'Go back'), className: styles.goBackLink, 
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick: function () {
                        var editUrl = _this.cartData._cartCreationSource === 'PSC' ?
                            '/buy/prepaid-phones/' : '/buy/wireless/prepaid';
                        if (_this.cartData._cartCreationSource === 'PSC') {
                            if (incompletePart === 'WLS_PLAN') {
                                _this.props.events.onEdit('WIRELESS', losg.pscEditUrl, 'Edit Line');
                            }
                            else if (incompletePart === 'WLS_DEVICE') {
                                _this.props.events.onEdit('WIRELESS', editUrl, 'Edit Line');
                            }
                        }
                        else {
                            if (incompletePart === 'WLS_PLAN') {
                                _this.props.events.onEdit('WIRELESS', editUrl + "/plans", 'Edit Line');
                            }
                            else if (incompletePart === 'WLS_DEVICE') {
                                _this.props.events.onEdit('WIRELESS', editUrl, 'Edit Line');
                            }
                        }
                    } }, _this.cartSummaryCMSData.mixAndMatchGoBack));
                var messageRender = (React.createElement("div", { className: postpaidLineItem, key: "Missing " + missingIndex },
                    React.createElement("i", { className: iconClasses.join(' '), role: "img", "aria-label": "add a line" }),
                    React.createElement("span", { className: linkClass.join(' ') },
                        messageToShow,
                        goBackLink)));
                return messageToShow ? messageRender : null;
            }));
    };
    PrepaidCart.LINE_ITEM_PRIORITY = ['DEVICE', 'FEATURE', 'ACTIVATION_FEE', 'ACCESSORY', 'SHAREDDATAFEATURE'];
    PrepaidCart.WIRELESS_LINE_ITEM_PRIORITY = ['DEVICE', 'DATAPLAN', 'ATTNEXTUP_FEE', 'DOWNPAYMENT', 'ADVANCEPAYMENT', 'FEATURE',
        'ACTIVATION_FEE', 'TRADEIN', 'PAYUP', 'PAYOFF', 'UPGRADEFEE', 'ACCESSORY', 'SHAREDDATAGROUP',
        'SHAREDDATAFEATURE', 'VOICEPLAN'];
    return PrepaidCart;
}(React.Component));
exports.default = PrepaidCart;
//# sourceMappingURL=PrepaidCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/PrepaidCart/PrepaidCart.js
// module id = 765
// module chunks = 8